import classNames from 'classnames';
import { isNull } from 'lodash';

import infoIcon from '../../assets/images/icon-outline-info.svg';
import { Tooltip } from '../../components/Tooltip/Tooltip';
import { PAYMENT_STATUS, STUDENT_SESSION_TYPE_KEYS } from '../../types/hubEnums';
import { Session, SessionPolicy } from '../../types/hubInterfaces';
import { isInternalStaffCheck } from '../../util/helper';

const SessionTag = ({
  session,
  className,
  policy,
}: {
  session: Session;
  policy?: SessionPolicy;
  className?: string;
}) => {
  let sessionType: string = '';
  let tooltipContent: string = '';

  const isFlexi =
    policy?.policyName === 'Flexi' ||
    policy?.policyName?.toLowerCase().includes('flexi') ||
    ['Flexi', 'Flexi 23', 'Flexi 24'].includes(policy?.policyName);

  const isInternalStaff = isInternalStaffCheck(policy?.policyName);

  switch (session.studentSessionType) {
    case STUDENT_SESSION_TYPE_KEYS.STARTER_PACK:
      sessionType = 'Starter Pack Session';
      tooltipContent =
        isFlexi || isInternalStaff
          ? 'A starter pack session can be rescheduled or cancelled without credit'
          : 'A starter pack session can be rescheduled or cancelled without credit, in line with our normal cancellation policies';
      break;
    case STUDENT_SESSION_TYPE_KEYS.IN_TERM:
      sessionType = 'In-Term Session';
      tooltipContent =
        isFlexi || isInternalStaff
          ? 'An in-term session can be rescheduled, paused or cancelled with credit, in line with our normal session cancellation policies'
          : 'An in-term session can be rescheduled or cancelled without credit, in line with our normal session cancellation policies';
      break;
    case STUDENT_SESSION_TYPE_KEYS.ON_DEMAND:
      sessionType = 'On-Demand Session';
      tooltipContent =
        isFlexi || isInternalStaff
          ? 'An on-demand session can be rescheduled or cancelled with credit, in line with our normal cancellation policies'
          : 'An on-demand session can be rescheduled or cancelled without credit, in line with our normal cancellation policies';
      break;
    case STUDENT_SESSION_TYPE_KEYS.SUMMER_HOLIDAY:
      sessionType = 'Summer Holiday Session';
      tooltipContent = 'A summer holiday session can be rescheduled or paused';
      break;
    case STUDENT_SESSION_TYPE_KEYS.SPRING_HOLIDAY:
    case STUDENT_SESSION_TYPE_KEYS.WINTER_HOLIDAY:
    case STUDENT_SESSION_TYPE_KEYS.AUTUMN_HOLIDAY:
      sessionType = 'School Holiday Session';
      tooltipContent =
        isFlexi || isInternalStaff
          ? 'A school holiday session can be rescheduled, paused or cancelled in line with our normal session cancellation policies'
          : 'A school holiday session can be rescheduled, or cancelled to receive a Cluey Voucher to use for a make-up session next term';
      break;
    case STUDENT_SESSION_TYPE_KEYS.MAKE_UP:
    default:
      sessionType = 'Make-Up Session';
      tooltipContent =
        'A make-up session can be rescheduled. Sessions booked with a Cluey Voucher are not eligible for credits if cancelled.';
      break;
  }

  if (!isNull(session.rescheduledDate)) {
    sessionType = 'Rescheduled Session';
    tooltipContent = 'A rescheduled session cannot be rescheduled again';
  }

  return (
    <>
      {![PAYMENT_STATUS.PENDING_PAYMENT, PAYMENT_STATUS.FAILED].includes(session.paymentStatus as PAYMENT_STATUS) ? (
        <Tooltip content={tooltipContent} position="bottom" tooltipClassName="!w-[200px]">
          <div
            tabIndex={0}
            className={classNames(
              'flex cursor-pointer flex-row items-center gap-x-1.5 rounded border border-[#D1D5D6] bg-white px-2 py-1',
              className
            )}
          >
            <span className="proxima-soft text-xs font-bold uppercase text-grey-400">{sessionType}</span>
            <img src={infoIcon} alt="info icon" height={16} width={16} />
          </div>
        </Tooltip>
      ) : null}
    </>
  );
};

export default SessionTag;
